import React, { FC } from 'react';
import { useStore } from 'react-redux';

import { biClickLink } from '../../../util/bi';
import { TRootState } from '../../reducers';
import { selectConversationId } from '../../selectors/chat';
import { selectFieldNodeId } from '../../selectors/field';
import { Button } from '../Button';

interface Props {
  url: string;
  label: string;
  className: string;
}

export const AlertCTAButton: FC<Props> = ({ url, label, className }) => {
  const store = useStore<TRootState>();

  const clickHandler = () => {
    const state = store.getState();

    biClickLink({
      link: url,
      label,
      isCta: true,
      node_id: selectFieldNodeId(state),
      conversation_id: selectConversationId(state),
    });
  };

  return (
    <Button link={url} className={className} onClick={clickHandler}>
      {label}
    </Button>
  );
};
